<script setup lang="ts">
/**
 * Public marketing shell: top nav + content + footer.
 *
 * Rendered for routes with `meta.layout === 'marketing'` (landing, docs,
 * models). Works for both guests and signed-in users — the nav adapts its
 * right-hand cluster based on `auth.me`.
 */
import PublicTopNav from '../components/PublicTopNav.vue';
import PublicFooter from '../components/PublicFooter.vue';
</script>

<template>
  <div class="min-h-screen flex flex-col bg-canvas">
    <PublicTopNav />
    <main class="flex-1">
      <slot />
    </main>
    <PublicFooter />
  </div>
</template>
